<template>
  <div class="shop-type-wrapper bg-white">
    <el-form :model="typeForm" :rules="rules" ref="typeForm" label-width="100px">
      <el-form-item label="上级分类" prop="power">
        <el-select v-model="typeForm.pid" placeholder="请选择上级分类" style="width: 100%;">
          <el-option
            v-for="item in parentList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分类名称" prop="name">
        <el-input v-model="typeForm.name" placeholder="请输入分类名称"></el-input>
      </el-form-item>
      <el-form-item label="分类图标(180*180)" prop="images">
        <el-upload
          class="avatar-uploader"
          ref="upload"
          :action="upUrl + '/Index/Other/upload'"
          :show-file-list="false"
          :name="'image'"
          :data="fileData"
          :on-success="handleSuccess"
        >
          <img v-if="typeForm.url" :src="typeForm.url" class="avatar">
          <i class="el-icon-plus avatar-uploader-icon" v-else></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input v-model="typeForm.sort" placeholder="请输入排序"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-radio-group v-model="typeForm.state">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="2">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('typeForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  merchantStoreProductCateDetails,
  merchantStoreProductOneCateList,
  saveMerchantStoreProductCate
} from "@/api/shop";
import {ONLINEHOST, QAHOST} from "@/config";

export default {
  name: "shop-type-edit",
  data() {
    return {
      limit: 1,
      parentList: [{id: 0, name: "顶级分类"}],
      typeForm: {
        pid: 0,
        name: '',
        icon: '',
        url: '',
        sort: 0,
        state: 1,
      },
      rules: {
        pid: [{required: true, message: '请选择上级分类', trigger: 'change'}],
        name: [{required: true, message: '请输入分类名称', trigger: 'blur'}],
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    fileData() {
      return {
        token: this.user.token,
        addWatermark: 0
      };
    },
    upUrl() {
      return (process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST) + '/'
    }
  },
  created() {
    this.$emit("setIndex", '/home/shop-type', "双暖商城 / 商品分类编辑", true);
    this.getOneCateList();
    if (Number(this.$route.params.id)) this.getDetail()
  },
  components: {},
  methods: {
    //  获取分类详情
    async getDetail() {
      let _data = await merchantStoreProductCateDetails(this.$route.params.id)
      this.typeForm = {
        pid: _data.data.pid,
        name: _data.data.name,
        icon: _data.data.icon,
        url: _data.data.icon ? this.upUrl + _data.data.icon : '',
        sort: _data.data.sort,
        state: _data.data.state,
      }
    },
    //  获取商品一级分类
    async getOneCateList() {
      let _data = await merchantStoreProductOneCateList()
      this.parentList = [...this.parentList, ..._data.data]
    },
    //  上传图片
    handleSuccess(file) {
      this.typeForm.icon = file.data
      this.typeForm.url = this.upUrl  + file.data
    },
    //  添加/修改分类
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await saveMerchantStoreProductCate(
        this.typeForm.pid,
        this.typeForm.name,
        this.typeForm.icon,
        this.typeForm.sort,
        this.typeForm.state,
        this.$route.params.id
      )
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$refs['upload'].clearFiles()
      this.$router.go(-1)
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.shop-type-wrapper {
  .avatar-uploader {
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        border-color: #409EFF;
      }
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
      border: 1px dashed #d9d9d9;
    }

    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }
}
</style>
